import {type TraderDBAccount, type AccountGroup} from './traderdb';

export type AccountItem = {
  accountId: number;
  description?: string;
  neoVestAccountCode?: string;
  accountCode?: string;
  isActive?: boolean;
  clearingDetails?: ClearingDetail[];
  accountOwner?: string;
  systemCode?: string;
};
export type ExecutionTag = {
  executionTagId?: number;
  memo?: string;
  execCode: string;
  customTag1?: string;
  customTag2?: string;
  customTag3?: string;
  accounts: AccountItem[];
  products?: string[];

};
export type ClearingDetail = {
  id: number;
  clearingString: string;
  isDefaultClearingAccount?: boolean;
  clearingAccountCode?: string;
  description?: string;
};
export type TradingAccount = {
  id?: string;
  accountId: string;
  accountCode: string;
  execCode: string;
  description: string;
  memo: string;
  clearingString: TraderDBAccount['clearingString'];
  notes: string[];
  tradeIntentionId?: string;
};

export type UserAccount = {
  memo?: string;
  execCode?: string;
  customTag1?: string;
  customTag2?: string;
  customTag3?: string;
  clearingString: string;
  accountDescription?: string;
  products?: string[];
  systemCode?: string;
  accountGroup: string;
  accountCode: string;
};

export type ReferenceAccount = {
  id: number;
  code: string;
  description: string;
  accountOwner: string;
  isActive: boolean;
  systemCode: string;
  neoVestAccountCode: string;
  reportingUnit: string;
  businessUnit: string;
  businessCategory: string;
  marginAccountType: string;
  migrationAccount: string;
  accountGroup: string;
  isGdp: boolean;
  parentAccount: number;
  hierarchyType: string;
  childCode: string;
  leiCode: string;
  cftcCode: string;
};

export type ClearingAccount = {
  id: number;
  isDefaultClearingAccount: boolean;
  clearingString: string;
  clearingAccountCode: string;
  brokerTerm: string;
  description: string;
  account: ReferenceAccount;
  mappingCode?: MappingCode;
};

export type MappingCode = {
  id: number;
  mappingCode: string;
  accountCode: string;

};

enum PermissionGroup {
  CAN_TRADE_FUTURES = 'CanTradeFutures',
  CAN_ACCESS_DATA = 'CanAccessData',
  CAN_TRADE_OPTIONS = 'CanTradeOptions',
  CAN_TRADE_ALGOS = 'CanTradeAlgos',
  CAN_VIEW = 'CanView',
}

type MarketDataProvider = {
  exchange: string;
  provider: string;
  realTime: boolean;
  delayed: boolean;
  level2: boolean;
};

type MarketDataProviders = Record<string, MarketDataProvider>;

export type UserAuthInfo = {
  accounts: Accounts;
  permissionGroups: PermissionGroup[];
  marketData: MarketDataProviders;
  trader: TraderDBAccount;
  accountGroups: AccountGroup[];
};

export type Accounts = {
  clearingStrings: string[];
  accounts: TraderDBAccount[];
  accountGroups: AccountGroup[];
};

export type AuthCallbackParamsState = {
  env: string;
  frontend: string;
  timezone: string;
};

export type AuthCallbackParams = {
  code: string;
  state?: string;
  session_state: string;
};
